<template>
  <section class="f-54">
    <div class="alive-3-content" ref="content">
      <div
        class="font-group"
        v-bg
        bg-url="@/v2/auto/assets/image/54/title-bg.png"
      >
        <div class="title f-center-title">魔法音坊，情感化音色私人 DIY</div>
        <div class="des f-center-sub-title">
          自由调节语速急缓、语调起伏、情绪浓度与性格特质，
        </div>
        <div class="des f-center-sub-title">
          从沉稳大叔到活泼少女，让 AI 管家拥有「人类级」声音情绪表达能力
        </div>
      </div>
      <div class="role-group">
        <div class="carousel">
          <div class="carousel-track" ref="carouselTrack">
            <!-- 原始卡片 -->
            <div
              v-for="(i, index) in roles"
              :key="`original-${index}`"
              class="card-container"
              @click="playVoice(index)"
            >
              <RoleBorder
                class="role_border"
                :style="{ color: i.themeColor }"
              />
              <m-video
                :ref="`playVideo${index}`"
                class="role_animation"
                muted
                src="@/v2/auto/assets/video/54/role_animation.mp4"
              />
              <img class="role_img" :src="i.src" alt="role" />
              <RoleFill
                :ref="`roleFill${index}`"
                class="role_fill"
                :style="{ color: i.themeColor }"
              />
              <audio controls playsinline :ref="`audio${index}`">
                <source :src="i.audio" type="audio/mpeg" />
              </audio>
              <div class="role_title">{{ i.title }}</div>
              <div class="role_des">{{ i.des }}</div>
              <div class="role_play_layer">
                <div class="role_play_layer_1" />
                <div
                  :ref="`rolePlayLayer2_${index}`"
                  class="role_play_layer_2"
                />
                <div :ref="`playRef${index}`" class="play-animation" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Role1 from '@/v2/auto/assets/image/54/role1.png'
import Role4 from '@/v2/auto/assets/image/54/role4.png'
import Role5 from '@/v2/auto/assets/image/54/role5.png'
import Role6 from '@/v2/auto/assets/image/54/role6.png'
import Role7 from '@/v2/auto/assets/image/54/role7.png'
import Role8 from '@/v2/auto/assets/image/54/role8.png'
import audio1 from '@/v2/auto/assets/audio/0.aac'
import audio4 from '@/v2/auto/assets/audio/3.aac'
import audio5 from '@/v2/auto/assets/audio/4.aac'
import audio6 from '@/v2/auto/assets/audio/5.aac'
import audio7 from '@/v2/auto/assets/audio/6.aac'
import audio8 from '@/v2/auto/assets/audio/7.aac'

import lottie from 'lottie-web'
import { CustomEase } from 'gsap/CustomEase'

import playJson from '@/v2/auto/assets/image/54/voice.json'
import RoleBorder from '@/v2/auto/assets/image/54/role_border.vue'
import RoleFill from '@/v2/auto/assets/image/54/role_fill.vue'
export default {
  name: 'BeautyAlive',
  components: {
    RoleBorder,
    RoleFill,
  },
  data() {
    return {
      preload_: true,
      playIndex: 0,
      isPlaying: false,
      roles: [],
    }
  },
  mounted() {
    this.initRoleList()
    this.$nextTick(() => {
      this.initRoleLottie()
    })
  },
  methods: {
    initRoleObj(title, des, src, audio, themeColor) {
      return {
        title,
        des,
        src,
        themeColor,
        playAnimation: null,
        audio,
      }
    },
    initRoleList() {
      this.roles = [
        this.initRoleObj(
          '河南憨哥',
          '俚语连珠 倔强憨厚',
          Role1,
          audio1,
          '#E5843A',
        ),
        this.initRoleObj(
          '乐呵老头',
          '腔调逗趣 爽朗诙谐',
          Role4,
          audio4,
          '#3C8D38',
        ),
        this.initRoleObj(
          '广西老表',
          '朴实热情 夹壮鼻音',
          Role5,
          audio5,
          '#2586B0',
        ),
        this.initRoleObj(
          '青岛小哥',
          '痞气上扬 开朗热情',
          Role6,
          audio6,
          '#25B098',
        ),
        this.initRoleObj(
          '妩媚御姐',
          '低回婉转 磁性质感',
          Role7,
          audio7,
          '#C54246',
        ),
        this.initRoleObj(
          '胡同侃爷',
          '京腔卷舌 侃侃而谈',
          Role8,
          audio8,
          '#A94A2F',
        ),
      ]
    },
    playVoice(index) {
      const role = this.roles[index]
      // playIndex < 0 说明已经暂停，再次点击应该重新播放
      if (this.playIndex < 0) {
        this.animationHandler(role, true, index)
        return
      }
      // 如果是同一个角色，停止播放
      if (this.playIndex === index) {
        this.animationHandler(role, false, index)
        return
      }
      // 停止上一个角色的播放
      const stopRole = this.roles[this.playIndex]
      this.animationHandler(stopRole, false, this.playIndex)
      // 播放当前角色的动画
      this.animationHandler(role, true, index)
    },
    animationHandler(role, isPlay, index) {
      const { playAnimation } = role
      const gsap = this.$gsap
      const audio = this.$refs[`audio${index}`]?.[0]
      const playVideo = this.$refs[`playVideo${index}`]?.[0]
      const roleFill = this.$refs[`roleFill${index}`]?.[0].$el
      const rolePlayLayer2 = this.$refs[`rolePlayLayer2_${index}`]?.[0]
      const ease = CustomEase.create('custom', '0.33, 0, 0.67, 1')
      const fadeOut = { opacity: 1, duration: 0.5, ease }
      const fadeIn = { opacity: 0, duration: 0.5, ease }
      const audioStopHandler = () => {
        audio.removeEventListener('ended', audioStopHandler)
        this.animationHandler(role, false, index)
      }
      this.isPlaying = isPlay
      if (isPlay) {
        this.playIndex = index
        gsap.to([playVideo, rolePlayLayer2], fadeOut)
        playVideo.currentTime = 0
        playVideo.play()
        gsap.to(roleFill, fadeIn)
        audio.currentTime = 0
        audio.play()
        audio.addEventListener('ended', audioStopHandler)
        playAnimation?.play()
      } else {
        this.playIndex = -1
        gsap.to([playVideo, rolePlayLayer2], { ...fadeIn, duration: 0.3 })
        playVideo.pause()
        gsap.to([roleFill], { ...fadeOut, duration: 0.3 })
        audio.pause()
        audio.removeEventListener('ended', audioStopHandler)
        playAnimation?.stop()
      }
    },
    initRoleLottie() {
      const initLottie = (el, json) => {
        if (el) {
          return lottie.loadAnimation({
            container: el,
            renderer: 'svg',
            loop: true,
            autoplay: false,
            animationData: json,
          })
        }
      }
      this.roles.forEach((role, index) => {
        this.$refs[`audio${index}`]?.[0].load()
        role.playAnimation = initLottie(
          this.$refs[`playRef${index}`]?.[0],
          playJson,
        )
      })
    },
  },
}
</script>

<style lang="less" scoped>
.f-54 {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #000000;
  margin-top: -5px;

  .alive-3-content {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .font-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ffffff;
    background-position-y: 30px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: 160px;
    padding: 40px;
    .title {
      font-weight: bold;
      text-align: center;
      display: inline-block;
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .des {
      text-align: center;
      line-height: 24px;
    }
  }

  .role-group {
    width: 100%;
    margin: 100px 0;

    .carousel {
      overflow: hidden;
      width: 100%;
    }

    .carousel-track {
      display: flex;
      overflow-x: scroll;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari, Opera */
      }
      gap: 30px;
      padding: 0 40px;
      white-space: nowrap;
      align-items: flex-end;
      will-change: transform;
    }

    .card-container {
      position: relative;
      flex-shrink: 0;
      color: #ffffff;
      width: 350px;
      height: 500px;

      .role_border {
        position: absolute;
        z-index: 0;
        bottom: 0;
      }
      .role_animation {
        position: absolute;
        width: 100%;
        z-index: 1;
        bottom: 0;
        opacity: 0;
      }
      .role_img {
        position: absolute;
        width: 100%;
        z-index: 2;
        bottom: 0;
      }
      .role_fill {
        position: absolute;
        z-index: 3;
        bottom: 0;
      }
      .role_title {
        font-size: 20px;
        font-weight: 600;
        position: absolute;
        bottom: 60px;
        left: 20px;
        z-index: 4;
      }

      .role_des {
        font-size: 14px;
        position: absolute;
        bottom: 33px;
        left: 20px;
        z-index: 4;
      }

      .global-animation {
        position: absolute;
        width: 100%;
        bottom: 0;
        border-radius: 24px;
        overflow: hidden;
        left: 0;
        z-index: 4;
      }

      .role_play_layer {
        position: absolute;
        width: 60px;
        height: 60px;
        border-radius: 100px;
        overflow: hidden;
        bottom: 23px;
        right: 23px;
        cursor: pointer;
        z-index: 5;
        .role_play_layer_1 {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: #ffffff4a;
        }
        .role_play_layer_2 {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0;
          z-index: 2;
          background: linear-gradient(
            134.57deg,
            #7b5efe 11.84%,
            #ec63bf 76.91%,
            #fa7260 95.59%
          );
        }
        .play-animation {
          position: absolute;
          z-index: 3;
        }
      }
    }
    audio {
      visibility: hidden;
    }
  }
}
</style>
